import React from "react";

export default function Info() {
  return (
    <>
      <h1 className="text-5xl text-white font-extrabold mb-8 pb-8 mt-10">
        Akbank Web3 Practicum <br /> Final Case
      </h1>
      <p className="content-text">
        Patika.dev için Akbank Web3 Practicum'un final case'i için hazırlanmış
        NFT Mint contractıdır.
      </p>
      <p className="content-text">
        Yapay zeka ile oluşturulmuş Akbank NFT'leri
      </p>
      <p className="content-text">
        Altın, Gümüş ve Bronz yazıya sahip NFT'leri Mint edebilirsiniz.
      </p>
      <p className="content-text">
        Mint edeceğiniz NFT'nizin değerini üzerindeki altın, gümüş ve bronz
        karakterler belirlemektedir.
      </p>
      <p className="content-text">
        Mint ettiğiniz NFT ile 1.000.000 TL kadar geri ödemesiz kredi
        çekebilirsiniz! Demeyi çok isterdim 😊 ama sadece eğlence amaçlı
        üretilen NFT'ler <i className="font-bold">Georli Test ağında</i>{" "}
        şimdilik hiçbir işlem görmemektedir...
      </p>
    </>
  );
}
